import loadFonts from './base/load-fonts';
import { latin } from '../data/fonts.json';

// list all languages here, setting which custom font set they'll use
const fontsByLanguage = {
  en: latin,
  de: latin,
  es: latin,
  zh: [],
  ch: [],
  fr: latin,
  //ja: japanese,
  //ko: korean,
  pt: latin,
  ru: [],

};

loadFonts(fontsByLanguage, window.customFontInfo)
  .catch((err) => {
    // add any error logging here
    throw new Error(err);
  });



// WEBPACK FOOTER //
// ./styleguide/src/assets/custom-fonts.js